import React from 'react'

const Footer = () => {
    return (
        <div className='py-5 border-t'>
            <p className="text-center">
                Made by <span className="underline"><a href='https://github.com/Elsayed23'>Elsayed Kewan</a></span>
            </p>
        </div>
    )
}

export default Footer